export default __webpack_public_path__ + "static/media/Inter-Regular.9ca9ba81.ttf";